import React from "react";

import { connect } from "react-redux";

import _ from "lodash";
import "./signin.css";

import { updateUser } from "store/actions/security";
import API from "api";
import Axios from "axios";

export const FormErrors = ({ formErrors }) => (
  <div className="formErrors">
    {Object.keys(formErrors).map((fieldName, i) => {
      if (formErrors[fieldName].length > 0) {
        return (
          <p key={i}>
            {fieldName} {formErrors[fieldName]}
          </p>
        );
      } else {
        return "";
      }
    })}
  </div>
);
class Profile extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      use: props.user || {},
      errors: [],
      message: "",
      error: "",
      submitting: false
    };
    API.profile()
      .then(response => {
        this.setState({
          user: response.data,
          fetching: false
        });
      })
      .catch(error => {
        // console.warn("error", error);
        if (error.response) {
          // The request was made and the server responded with a status code
          // that falls out of the range of 2xx
          // console.log(error.response.status);
          // console.log(error.response.headers);
          this.setState({
            fetching: false,
            error: error.response.data.message,
            errors: error.response.data.errors.form.children
          });
        } else if (error.request) {
          // The request was made but no response was received
          // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
          // http.ClientRequest in node.js
          // console.log(error.request);
          this.setState({
            fetching: false,
            error: error.message || "Error lors de l'authentification"
          });
        } else {
          // Something happened in setting up the request that triggered an Error
          // console.log('Error', error.message);
          this.setState({ fetching: false, error: error.message });
        }
      });
  }

  getError(field) {
    let errors = this.state.errors || {};
    let error = errors.children ? errors.children[field] : undefined;
    if (error !== undefined && error.errors && error.errors.length > 0) {
      error = { message: _.join(error.errors, ", ") };
    }

    return _.find(errors, { property_path: field }) || error;
  }
  renderFieldError(field) {
    let error = this.getError(field);
    if (error === undefined) return null;
    return <small className="text-danger">{error.message}</small>;
  }
  saveProfile = e => {
    e.preventDefault();
    const user = this.state.user || {};

    this.setState({ submitting: true, error: "" });

    API.profileEdit(user)
      .then(response => {
        const { user, message } = response.data;
        // login user;
        const expiresAt = new Date();
        user.last_login = new Date();
        expiresAt.setDate(expiresAt.getDate() + 7);
        Axios.defaults.headers.common["Authorization"] = user.api_key;
        user.accessUntil = expiresAt;

        this.setState(
          {
            error: null,
            message,
            submitting: false
          },
          () => {
            this.props.updateUser(user);
          }
        );
      })
      .catch(error => {
        let message = error.message;
        let errors = [];

        if (error.response) {
          message = "";
          errors = error.response.data.validationErrors;
        } else {
        }
        this.setState({
          error: message,
          errors,
          submitting: false
        });
      });
  };

  handleInput = e => {
    const name = e.target.name;
    const value =
      e.target.type === "checkbox" ? e.target.checked : e.target.value;
    let modelName = e.target.dataset.model || null;

    let model = null;
    if (modelName) {
      model = { ...this.state[modelName] };
    }
    model[name] = value;

    this.setState({ [modelName]: model });
  };

  render() {
    const { submitting, message, error, user } = this.state;
    if (user === undefined) return null;

    if (this.props.isAuth) {
      // return (
      //   <Redirect
      //     to={{
      //       pathname: "/publications",
      //       state: { from: this.props.location }
      //     }}
      //   />
      // );
    }
    return (
      <div className=" min-vh-100 d-flex  justify-content-center align-items-center">
        <div className="wrapper fadeInDown">
          <div className="formContent">
            <div className="fadeIn first">
              {/* <img
                src="http://danielzawadzki.com/codepen/01/icon.svg" 
                id="icon"
                alt="User Icon"
              /> */}
            </div>

            <form
              method="post"
              className="my-3 d-flex flex-column align-items-center px-4"
            >
              {error && <p className="text-danger text-center">{error}</p>}
              {message && <p className="text-success text-center">{message}</p>}

              <input
                type="text"
                className="fadeIn second"
                name="lastname"
                placeholder="Nom"
                value={user.lastname || ""}
                data-model="user"
                disabled={submitting}
                onChange={this.handleInput}
              />
              {this.renderFieldError("firstName")}
              <input
                type="text"
                className="fadeIn second"
                name="firstname"
                data-model="user"
                placeholder="Prénom"
                value={user.firstname || ""}
                disabled={submitting}
                onChange={this.handleInput}
              />
              {this.renderFieldError("lastName")}

              <input
                type="text"
                className="fadeIn second"
                name="email"
                data-model="user"
                placeholder="Email"
                value={user.email}
                disabled={submitting}
                onChange={this.handleInput}
              />
              {this.renderFieldError("email")}

              <input
                type="text"
                className="fadeIn second"
                name="mobile_phone"
                data-model="user"
                placeholder="Téléphone"
                disabled={submitting}
                onChange={this.handleInput}
              />
              {this.renderFieldError("mobilePhone")}

              <button
                type="button"
                disabled={submitting}
                className="btn btn-ikea btn-block my-4 fadeIn fourth"
                onClick={this.saveProfile}
              >
                Enregistrer
              </button>
            </form>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  user: state.security.user,
  isAuth: Boolean(state.security.user)
});
const binActionsToProps = dispatch => ({
  updateUser: user => dispatch(updateUser(user))
});
export default connect(mapStateToProps, binActionsToProps)(Profile);
